import { BaseRow } from 'components/Table/types';

import { NameColumnProps } from './types';
import Column from '../Column';
import { useTranslation } from 'react-i18next';

function NameColumn<TRow extends BaseRow>(props: NameColumnProps<TRow>) {
  const { t } = useTranslation('common');
  return <Column<TRow> {...props} title={t('name')} name='name' />;
}

export default NameColumn;
